import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

export type ChartUiContextType = {
    expandedSubsampleChartId: string | null;
    setExpandedSubsampleChartId: React.Dispatch<React.SetStateAction<string | null>>;
};

const defaultChartUiContextData: ChartUiContextType = {
    expandedSubsampleChartId: null,
    setExpandedSubsampleChartId: () => {},
} as const;

const ChartUiContext = createContext(defaultChartUiContextData);

const ChartUiContextProvider = ({ children }: { children: ReactNode }) => {
    const [expandedSubsampleChartId, setExpandedSubsampleChartId] = useState<string | null>(null);

    const contextValue: ChartUiContextType = useMemo(
        () => ({
            expandedSubsampleChartId,
            setExpandedSubsampleChartId,
        }),
        [expandedSubsampleChartId]
    );

    return <ChartUiContext.Provider value={contextValue}>{children}</ChartUiContext.Provider>;
};

const useChartUiContext = () => useContext(ChartUiContext);

export { ChartUiContextProvider, useChartUiContext };
